import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { IconCheck, IconX } from '@tabler/icons-react'
import urlParser from "js-video-url-parser/dist/jsVideoUrlParser.js?v=1.2";
import DemoVideoPlay from "../../../Dashboard/DemoVideoPlay";

const ProductItem = forwardRef(
  function ProductItem(props, ref) {
    const [title, setTitle] = useState("");
    const [youtubeLink, setYoutubeLink] = useState("");
    const [ecommerceLink, setEcommerceLink] = useState("");
    const [category, setCategory] = useState("");
    const [isOpen, setIsOpen] = useState("");
    const [errors, setErrors] = useState({});
    const [showDelete, setShowDelete] = useState(false);
    const [categories, setCategories] = useState([]);
    const [thumbnail, setThumbnail] = useState("");
    const [embedLink, setEmbedLink] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [description, setDescription] = useState("");
    const [primary, setPrimary] = useState(false);
    const [id, setId] = useState(props.data.id);

    useEffect(() => {
      if (props.data) {
        setTitle(props.data.title);
        setYoutubeLink(props.data.youtubeLink);
        setEcommerceLink(props.data.ecommerceLink);
        setCategory(props.data.category);
        setDescription(props.data.description);
        setPrimary(props.data.isPrimary);
      }
    }, [props.data])

    useEffect(() => {
      if (props.categories) {
        setCategories(props.categories);
      }
    }, [props.categories]);

    useEffect(() => {
      setIsOpen(props.data.show);
    }, [props.data.show]);

    useEffect(() => {
      setShowDelete(props.showDelete);
    }, [props.showDelete]);

    useEffect(() => {
      setPrimary(props.data.isPrimary);
    }, [props.data.isPrimary]);

    useEffect(() => {
      if (youtubeLink && youtubeLink.trim() !== "") {
        let parsedData = urlParser.parse(youtubeLink);
        if (parsedData && parsedData?.id && parsedData.id != "") {
          setThumbnail(`https://img.youtube.com/vi/${parsedData.id}/0.jpg`);
          setEmbedLink(`https://www.youtube.com/embed/${parsedData.id}`);
        }
        else {
          setThumbnail("");
          setEmbedLink("");
        }
      }
      else {
        setThumbnail("");
        setEmbedLink("");
      }
    }, [youtubeLink])


    const validate = () => {
      const errors = {};
      if (!title || (title && title.trim() == "")) {
        errors.title = "Product name is required";
      }

      if (!category || (category && category.trim() == "")) {
        errors.category = "Category is required";
      }

      if (!youtubeLink || (youtubeLink && youtubeLink.trim() == "")) {
        errors.youtubeLink = "Youtube url is required";
      }

      if (youtubeLink && youtubeLink.trim() !== "") {
        let parsedData = urlParser.parse(youtubeLink);
        if (!(parsedData && parsedData?.id && parsedData.id != "")) {
          errors.youtubeLink = "Invalid youtube Url";
        }
      }

      setErrors(errors);
      return Object.keys(errors).length === 0;
    }

    const getData = () => {
      return {
        id: id,
        title: title,
        youtubeLink: youtubeLink,
        ecommerceLink: ecommerceLink,
        category: category,
        description: description,
        isPrimary: primary
      }
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    const playVideoHandler = (e) => {
      e.preventDefault();
      setShowModal(true);
    }

    const closeModal = () => {
      setShowModal(false);
    }

    return (
      <>
        <div className="card accordion-item ">
          <h2 className="accordion-header">
            <button type="button"
              onClick={() => props.showHideProduct(props.index)}
              className={`accordion-button align-items-center ${isOpen ? "" : "collapsed"}`}>
              {title}
              {primary && (
                <span className="bg-success ms-2 px-2 badge">Primary</span>
              )}
            </button>
          </h2>

          <div className={`accordion-collapse ${isOpen ? "show" : "collapse"}`}>
            <div className="accordion-body mt-3">
              <div className="row">
                <div className="col-lg-8 col-12">
                  <div className="row">
                    <div className="col-md-6 mt-2">
                      <label className="form-label required">
                        Product Name
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.title ? "is-invalid" : ""}`}
                        placeholder="Enter product name"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                      {errors.title && (
                        <div className="invalid-feedback">
                          {errors.title}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mt-2">
                      <label className="form-label required">
                        Category
                      </label>

                      <select
                        id="category"
                        name="category"
                        className={`form-control ${errors.category ? "is-invalid" : ""}`}
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        placeholder="Please select category">
                        <option value="">
                          Select
                        </option>
                        {categories.length > 0
                          && categories.map((cat, index) => {
                            return (<option value={cat.title} key={index}>
                              {cat.title}
                            </option>);
                          })
                        }
                      </select>

                      {errors.category && (
                        <div className="invalid-feedback">
                          {errors.category}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mt-4">
                      <label className="form-label required">
                        Video Link
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.youtubeLink ? "is-invalid" : ""}`}
                        placeholder="Enter video link"
                        value={youtubeLink}
                        onChange={(e) => setYoutubeLink(e.target.value)}
                      />
                      <small>Add any public Youtube link</small>
                      {errors.youtubeLink && (
                        <div className="invalid-feedback">
                          {errors.youtubeLink}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mt-4">
                      <label className="form-label">
                        Purchase Link
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter purchase link"
                        value={ecommerceLink}
                        onChange={(e) => setEcommerceLink(e.target.value)}
                      />
                    </div>
                    <div className="col-12 mt-4">
                      <label className="form-label">
                        Description
                      </label>
                      <textarea
                        style={{ height: "110px", resize: "none" }}
                        className="form-control"
                        placeholder="Enter description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12">
                  {
                    thumbnail != "" && (
                      <div className="position-relative youtube">
                        <img className="img-fluid thumbnail" src={thumbnail} width="100%" />
                        <div className="position-absolute top-50 start-50 translate-middle" onClick={playVideoHandler}>
                          <img src="https://img.icons8.com/doodle/48/null/youtube-play--v2.png" alt="play" className="play-icon" style={{ cursor: "pointer" }} />
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
              <div className="d-flex">
                <div className="mt-3 me-4">
                  <button type="button" className="btn btn-label-success"
                    onClick={() => props.setAsPrimary(props.index)}>
                    <IconCheck className="me-1" size={16} />
                    <span className="align-middle">Set as Primary</span>
                  </button>
                </div>
                {showDelete && (
                  <div className=" mt-3">
                    <button type="button" className="btn btn-label-danger"
                      onClick={() => props.deleteProduct(props.index)}>
                      <IconX className="me-1" size={16} />
                      <span className="align-middle">Delete</span>
                    </button>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
        {
          showModal && (
            <DemoVideoPlay url={embedLink}
              onClose={closeModal}
              alt={title} />)
        }
      </>
    )
  });

export default ProductItem;
